import { Box, Center, Flex, Grid, Text } from "@chakra-ui/react";
import { Button } from "@raiden/library-ui/components/ui";
import { RevealVertically } from "@raiden/library-ui/components/Animations/RevealVertically";
import { CAMPAIGNS_TYPE_VALUE_THEMATIC } from "@raiden/library-ui/constants/campaigns";
import { useSearchInfiniteContext } from "@raiden/library-ui/contexts/SearchInfinite/useSearchInfiniteContext";
import { Fragment, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { CampaignCard } from "../../../components/Campaigns/Card";
import { DataHandlerInfinite } from "@raiden/library-ui/components/DataHandlerInfinite";
import { Disable } from "../../../components/Disable";
import { Icon } from "@raiden/library-ui/components/Icon";
import { SimpleResultsGrid } from "./SimpleResultsGrid";
import encodeQuery from "@splitfire-agency/raiden-library/dist/libraries/utils/encodeQuery";

/**
 * @param {string} area
 * @returns {number}
 */
function getAspectRatio(area) {
  if (area === "b" || area === "d" || area === "i" || area === "k") {
    return 532 / 258;
  }
  return 1;
}

/**
 * @typedef {object} Props
 * @property {import("@raiden/library-ui/types/Campaign").CampaignType} campaignType
 * @property {string} campaignUrl
 */
/**
 * @param {Props} props
 */
export function Results({ campaignType, campaignUrl }) {
  /** @type {import("@raiden/library-ui/contexts/SearchInfinite/useSearchInfiniteContext").UseSearchInfiniteReturn<import(".").CampaignSearchFormValues, import("@raiden/library-ui/types/Campaign").Campaign[]>} */
  const { swrInfiniteResponse, submittedFields } = useSearchInfiniteContext();

  const [forceEnable, setForceEnable] = useState(true);

  useEffect(() => {
    setForceEnable(false);
  }, []);

  return (
    <Disable isDisabled={swrInfiniteResponse.isValidating && !forceEnable}>
      <DataHandlerInfinite
        swrInfiniteResponse={swrInfiniteResponse}
        keepPreviousData={true}>
        {(pages) => {
          return (
            <Box>
              {campaignType === CAMPAIGNS_TYPE_VALUE_THEMATIC ? (
                <>
                  <Grid
                    display={{ base: "none", lg: "grid" }}
                    w="full"
                    alignItems="stretch"
                    gridTemplate={`
                  "a b b c"
                  "d d e f"
                  "g h i i"
                  "j k k l"
                `}
                    gridGap="1rem">
                    {pages.map((page, index) => (
                      <Fragment key={index}>
                        {[
                          "a",
                          "b",
                          "c",
                          "d",
                          "e",
                          "f",
                          "g",
                          "h",
                          "i",
                          "j",
                          "k",
                          "l",
                        ].map((area, areaIndex) => {
                          const campaign = page.data[areaIndex];
                          if (!campaign) {
                            return null;
                          }
                          return (
                            <Flex
                              alignItems="stretch"
                              gridArea={area}
                              key={campaign.id}
                              sx={{
                                "& > *": {
                                  flexGrow: 1,
                                },
                              }}>
                              <CampaignCard
                                campaign={campaign}
                                aspectRatio={getAspectRatio(area)}
                                key={campaign.id}
                              />
                            </Flex>
                          );
                        })}
                      </Fragment>
                    ))}
                  </Grid>

                  <Box display={{ base: "block", lg: "none" }}>
                    <SimpleResultsGrid pages={pages} />
                  </Box>
                </>
              ) : (
                <SimpleResultsGrid pages={pages} />
              )}

              <RevealVertically
                isVisible={
                  pages[pages.length - 1].meta?.current_page <
                  pages[pages.length - 1].meta?.last_page
                }>
                <Center pt="1rem">
                  <Box backgroundColor="#fff" borderRadius="10px">
                    <Button
                      as="a"
                      href={`${campaignUrl}${encodeQuery(
                        {
                          ...submittedFields,
                          page: pages[pages.length - 1].meta?.current_page + 1,
                        },
                        {
                          appendPrefix: true,
                        },
                      )}`}
                      onClick={(event) => {
                        event.preventDefault();
                        swrInfiniteResponse.setSize((size) => size + 1);
                      }}
                      isLoading={
                        swrInfiniteResponse.isValidating && !forceEnable
                      }
                      variant="outline"
                      rightIcon={<Icon icon="ms_expand_more" />}
                      borderRadius="10px"
                      size="sm">
                      <Text as="span" variant="button-sm">
                        <FormattedMessage defaultMessage="Voir plus" />
                      </Text>
                    </Button>
                  </Box>
                </Center>
              </RevealVertically>
            </Box>
          );
        }}
      </DataHandlerInfinite>
    </Disable>
  );
}
